<template>
  <Header />
  <Logos />
  <Webpages/>
  <Footer />
  <Copyright />

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Logos from "@/components/Logos.vue";
import Webpages from "@/components/Webpages.vue";
import Footer from "@/components/Footer.vue";
import Copyright from "@/components/Copyright.vue";

export default {
  name: "Home",
  components: {
    Header,
    Logos,
    Webpages,
    Footer,
    Copyright,
  } 
};
</script>

<style>
.link-portfolio{
  text-decoration: none;
  color: #E50051;
  transition: all 200ms ease;
}


.link-portfolio:hover{
  color: #A30039;
}
</style>